module.exports = __webpack_public_path__ + "assets/img/52f200245d7d305fd6d06def214f7224.svg";